import { style } from '@vanilla-extract/css'

const cell = style({
  fontSize: '15px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

const totalCell = style({
  fontFamily: 'Noto Sans Variable, sans-serif',
  fontSize: '19px',
  fontWeight: '700',
  lineHeight: '1.5',
})

const divider = style({
  backgroundImage: 'linear-gradient(to right, #828282, #828282 3px, transparent 3px)',
  backgroundSize: '8px 1px',
  backgroundRepeat: 'repeat-x',
  backgroundPosition: 'center',
  border: 'none',
  height: '1px',
})

export const styles = {
  cell,
  totalCell,
  divider,
}
